import { IStationData } from '@cian/underground-map-widget';
import * as React from 'react';
import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../common/state';
import { EMetroTravelType } from '../../../json_query';
import { removeMetro, selectMetro } from '../../state/metro/changed';
import { applyMetroModal } from '../../state/metro/save_modal';
import { closeMetroModal } from '../../state/metro/toggle_modal';
import { changeUndergroundTravelWithSearch } from '../../state/underground_travel';
import { SearchButtonContainer } from '../search_button/container';
import { MetroModal } from './index';

export const MetroContainer = connect(
  (state: IAppState) => {
    const selectedIds =
      state.filters.jsonQuery.geo &&
      state.filters.jsonQuery.geo.value.reduce((acc: number[], value) => {
        if (value.type === 'underground') {
          acc.push(Number(value.id));
        }

        return acc;
      }, []);

    const travelType =
      (state.filters.jsonQuery.only_foot && state.filters.jsonQuery.only_foot.value) || EMetroTravelType.Any;

    return {
      undergroundMapSchemeWidgetService: state.widgets && state.widgets.undergroundMapSchemeWidgetService,
      selectedIds,
      location: state.filters.currentLocation,
      travelType,
      travelTime: state.filters.jsonQuery.foot_min && state.filters.jsonQuery.foot_min.value.lte,
      stationsUnderConstruction: state.constructingStations && Object.keys(state.constructingStations).map(Number),
    };
  },
  (dispatch: Dispatch) => ({
    onSelect: (stations: IStationData[]) => {
      dispatch(selectMetro(stations));
    },
    onRemove: (stations: IStationData[]) => {
      dispatch(removeMetro(stations));
    },
    onUndergroundTravelChanged: (travelType: EMetroTravelType, travelTime: number | undefined) => {
      dispatch(changeUndergroundTravelWithSearch(travelType, travelTime));
    },
    onClose: () => {
      dispatch(closeMetroModal());
    },
    searchButton: (
      <SearchButtonContainer
        onClick={() => {
          dispatch(applyMetroModal());
        }}
      />
    ) as React.ReactNode,
  }),
)(MetroModal);
